import React, { useContext, useEffect, useState } from "react";

import { getShipment, getLabels, getLookups, getProducts, getDueDates } from "./lib/binLabelData";

import BackToButton from "../task-nav/backToButton";
import BinLabel from "./label";
import Loading from "../callback/loading";
import NotificationBar from "../notification-bar";
import { useAlert } from "hooks/useAlert";
import { SettingsContext } from "contexts/settings";

import "./bin-label.scss";
import { useNavigate, useParams } from "react-router-dom";

const delay = (ms) => {
    return new Promise((resolve) => setTimeout(resolve, ms));
};

const BinLabelIndex = () => {
    const navigate = useNavigate();
    const params = useParams();
    const { toggleAlert } = useAlert();
    const { settings } = useContext(SettingsContext);
    const isDelay = !!params.delay;
    const [labels, setLabels] = useState([]);
    const [hasDates, setHasDates] = useState(true);
    const [isLoading, setIsLoading] = useState(isDelay);

    useEffect(() => {
        if (settings.globalNotifications.messages.length) {
            toggleAlert();
        }
    }, [settings.globalNotifications.messages.length]);

    useEffect(() => {
        const buildData = async () => {
            const shipmentKey = params.id;

            if (isDelay) {
                await delay(4500);
            }

            const shipment = await getShipment(shipmentKey);
            const bins = await getLabels(shipmentKey);
            const lookup = await getLookups();
            const products = await getProducts(shipmentKey);
            const isInDuplicateStaging = shipment.isInDuplicateStaging;
            const dueDates = await getDueDates(products[0].key, isInDuplicateStaging);
            const productCount = products.length || 0;
            const datesLength = dueDates.length > 0;

            const labelsData = bins.map((bin) => {
                const found = lookup.finalDestinations.find((f) => {
                    return f.code === shipment.finalDestination;
                });
                const destination = found ? found.text : "";

                return {
                    binId: bin,
                    client: shipment.cxHClient.name,
                    upcCount: productCount,
                    due: shipment.dueOn,
                    dueDates: dueDates,
                    destination: destination,
                    isPerishable: shipment.isPerishable,
                    received: shipment.receivedOn,
                    rush: shipment.isRush,
                    supplier: shipment.supplier.name,
                    trackingNumbers: products[0].trackingNumbers || [],
                };
            });
            setLabels(labelsData);
            setHasDates(datesLength);
            setIsLoading(false);

            if (datesLength) {
                setTimeout(() => {
                    window.print();
                }, 500);
            }
        };

        buildData();
    }, []);

    const backToList = (e) => {
        e.preventDefault();
        navigate("/shipments");
    };

    return (
        <div className="container">
            <div className="button-group">
                <BackToButton
                    text="Back to Shipments"
                    onClick={backToList}
                />
            </div>
            {!hasDates && <NotificationBar message="Task due dates appear to be missing, please try reloading." />}
            {isLoading && <Loading />}
            <BinLabelMain labels={labels} />
        </div>
    );
};

const BinLabelMain = (props) => {
    const labels = props.labels;

    const total = labels.length;
    const labelHtml = labels.map((label, index) => {
        let num = index + 1;
        const pageBreak = num < total ? <div className="page-break"></div> : "";

        return (
            <div key={index}>
                <BinLabel
                    label={label}
                    index={num}
                    total={total}
                />
                {pageBreak}
            </div>
        );
    });

    return <div>{labelHtml}</div>;
};

export default BinLabelIndex;
